import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'product-table',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class ProductTable {
  @Input() title: string;
  @Input() datasource: any;
  @Input() displayedColumns: any;

  @Output() onGuestList: EventEmitter<any> = new EventEmitter();

  ngOnInit() {
  }
  // guestList(row: any): void {
  //   this.onGuestList.emit(row);
  // }
}
